import { IProductVariant } from "@/interfaces/product";
import { formatPrice } from "@/utils/format";

interface InventoryPrice {
  variants: IProductVariant[];
}

const InventoryPrice: React.FC<InventoryPrice> = (props) => {
  const { variants } = props;
  return (
    <section className="w-full max-w-6xl mx-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-100 flex py-2 font-medium">
            <th className="flex-2">Product</th>
            <th className="flex-1">SKU</th>
            <th className="flex-1">Color</th>
            <th className="flex-1">In Stock</th>
            <th className="flex-1">Unit Price</th>
          </tr>
        </thead>
        <tbody>
          {variants.map((item) => {
            const { id, name, sku, color, totalInventory, price } = item;
            return (
              <tr key={id} className="flex border py-2 items-center">
                <td className="flex-2 flex justify-center pl-2">{name}</td>
                <td className="flex-1 flex justify-center">{sku}</td>
                <td className="flex-1 flex justify-center">
                  <div
                    key={id}
                    style={{ backgroundColor: `${color}` }}
                    className={`size-8 border border-gray-300 rounded-md`}
                  />
                </td>
                <td className="flex-1 flex justify-center">{totalInventory}</td>
                <td className="flex-1 flex justify-center">
                  {formatPrice(price)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};

export default InventoryPrice;
